class SteelDialogComponent extends HTMLElement {

  barsCrossTensionFailure = false
  barsPreventTensionBreakout = false
  shearXNumber4Bars = false
  shearXStirrups = false
  shearXNoBreakout = false
  shearYNumber4Bars = false
  shearYStirrups = false
  shearYNoBreakout = false

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.steel), true)
    this.addEventListener('show.bs.modal', this.configure)
  }

  /**
   * Create our view model and configure the view
   * @param {Steel} model
   * 
   */
   onProjectLoaded(model) {
    this.barsCrossTensionFailure = model.barsCrossTensionFailure
    this.barsPreventTensionBreakout = model.barsPreventTensionBreakout
    this.shearXNumber4Bars = model.shearXNumber4Bars
    this.shearXStirrups = model.shearXStirrups
    this.shearXNoBreakout = model.shearXNoBreakout
    this.shearYNumber4Bars = model.shearYNumber4Bars
    this.shearYStirrups = model.shearYStirrups
    this.shearYNoBreakout = model.shearYNoBreakout
    this.updateSteelButtons()
  }

  configure() {
    document.getElementById("tension-bars").checked = this.barsCrossTensionFailure
    document.getElementById("tension-bars-prevent-breakout").checked = this.barsPreventTensionBreakout
    
    if(this.barsCrossTensionFailure) {
      document.getElementById("tension-bars-prevent-breakout").disabled = false
      document.getElementById("tension-bars-prevent-breakout-label").classList.remove('text-muted')
    } else {
      document.getElementById("tension-bars-prevent-breakout").disabled = true
      document.getElementById("tension-bars-prevent-breakout-label").classList.add('text-muted')
    }
    
    document.getElementById("shear-x-bars").checked = this.shearXNumber4Bars
    document.getElementById("shear-x-stirrups").checked = this.shearXNumber4Bars && this.shearXStirrups
    document.getElementById("shear-x-breakout").checked = this.shearXNoBreakout

    if(this.shearXNumber4Bars) {
      document.getElementById("shear-x-stirrups").disabled = false
      document.getElementById("shear-x-stirrups-label").classList.remove('text-muted')
    } else {
      document.getElementById("shear-x-stirrups").disabled = true
      document.getElementById("shear-x-stirrups-label").classList.add('text-muted')
    }
    
    document.getElementById("shear-y-bars").checked = this.shearYNumber4Bars
    document.getElementById("shear-y-stirrups").checked = this.shearYNumber4Bars && this.shearYStirrups
    document.getElementById("shear-y-breakout").checked = this.shearYNoBreakout

    if(this.shearYNumber4Bars) {
      document.getElementById("shear-y-stirrups").disabled = false
      document.getElementById("shear-y-stirrups-label").classList.remove('text-muted')
    } else {
      document.getElementById("shear-y-stirrups").disabled = true
      document.getElementById("shear-y-stirrups-label").classList.add('text-muted')
    }
  }

  publishUpdate() {
    this.updateSteelButtons()    
    const event = new CustomEvent('steel-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  updateSteelButtons() {
    let str = this.barsCrossTensionFailure ? '<div>Bars cross tension failure plane (D.5.2.9)</div>' : ''
    str += this.barsPreventTensionBreakout ? '<div>Bars sized to prevent Tension Concrete Breakout (D.5.2.9)</div>' : ''
    str = str === '' ? '<div>None</div>' : str
    document.getElementById('tension-steel-button').innerHTML = '<strong>Tension Steel</strong>' + str
    
    str = this.shearXNumber4Bars ? '<div>No. 4 bar or greater between anchor and edge (D.6.2.7)</div>' : ''
    str += this.shearXStirrups ? '<div>Enclosed by stirrups (spaced at 4" max) (D.6.2.7)</div>' : ''
    str += this.shearXNoBreakout ? '<div>Horizontal bars sized to prevent Concrete Breakout (D.6.2.9)</div>' : ''
    str = str === '' ? '<div>None</div>' : str
    document.getElementById('shear-x-steel-button').innerHTML = '<strong>Shear X Steel</strong>' + str
      
    str = this.shearYNumber4Bars ? '<div>No. 4 bar or greater between anchor and edge (D.6.2.7)</div>' : ''
    str += this.shearYStirrups ? '<div>Enclosed by stirrups (spaced at 4" max) (D.6.2.7)</div>' : ''
    str += this.shearYNoBreakout ? '<div>Horizontal bars sized to prevent Concrete Breakout (D.6.2.9)</div>' : ''
    str = str === '' ? '<div>None</div>' : str
    document.getElementById('shear-y-steel-button').innerHTML = '<strong>Shear Y Steel</strong>' + str
  }

  onClick() {
    this.barsCrossTensionFailure = document.getElementById("tension-bars").checked
    this.barsPreventTensionBreakout = this.barsCrossTensionFailure && 
    document.getElementById("tension-bars-prevent-breakout").checked
    
    this.shearXNumber4Bars = document.getElementById("shear-x-bars").checked
    this.shearXStirrups = document.getElementById("shear-x-stirrups").checked
    this.shearXNoBreakout = document.getElementById("shear-x-breakout").checked
    
    this.shearYNumber4Bars = document.getElementById("shear-y-bars").checked
    this.shearYStirrups = document.getElementById("shear-y-stirrups").checked
    this.shearYNoBreakout = document.getElementById("shear-y-breakout").checked
    this.configure()
    this.publishUpdate()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-steel-dialog" tabindex="-1" role="dialog" aria-labelledby="myModalShapeLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Specify Steel</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="bs-component">
              <!-- Table -->
              <form id="steel-form">
                <div>
                  <p><strong>Tension Steel</strong></p>
                  <div>
                    <input type="checkbox" value="" id="tension-bars">
                    <label> Bars cross tension failure plane (D.5.2.9)</label>
                  </div>
                  <div>
                    <input type="checkbox" id="tension-bars-prevent-breakout" disabled>
                    <label id="tension-bars-prevent-breakout-label" for="tension-bars-prevent-breakout">
                      Bars sized to prevent Tension Concrete Breakout (D.5.2.9)
                    </label>
                  </div>
                  <br>
                </div>
                <div>
                  <p><strong>X Shear Steel</strong></p>
                  <div>
                    <input type="checkbox" value="" id="shear-x-bars"> 
                    <label> No. 4 bar or greater between anchor and edge (D.6.2.7)</label>
                  </div>
                  <div>
                    <input type="checkbox" value="" id="shear-x-stirrups" disabled> 
                    <label id="shear-x-stirrups-label"> Enclosed by stirrups (spaced at 4" max) (D.6.2.7)</label>
                  </div>
                  <div>
                    <input type="checkbox" value="" id="shear-x-breakout">
                    <label> Horizontal bars sized to prevent Concrete Breakout (D.6.2.9)</label>
                  </div>
                  <br>
                </div>
                <div>
                  <p><strong>Y Shear Steel</strong></p>
                  <div><label><input type="checkbox" value="" id="shear-y-bars"> No. 4 bar or
                      greater between anchor and edge (D.6.2.7)</label></div>
                  <div><label id="shear-y-stirrups-label">
                      <input type="checkbox" value="" id="shear-y-stirrups" disabled> Enclosed by
                      stirrups (spaced at 4" max) (D.6.2.7)
                    </label>
                  </div>
                  <div><label><input type="checkbox" value="" id="shear-y-breakout">
                      Horizontal bars sized to prevent Concrete Breakout (D.6.2.9)</label>
                  </div>
                  <br>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById("tension-bars").onclick = () => this.onClick()
    document.getElementById("tension-bars-prevent-breakout").onclick = () => this.onClick()
    
    document.getElementById("shear-x-bars").onclick = () => this.onClick()
    document.getElementById("shear-x-stirrups").onclick = () => this.onClick()
    document.getElementById("shear-x-breakout").onclick = () => this.onClick()

    document.getElementById("shear-y-bars").onclick = () => this.onClick()
    document.getElementById("shear-y-stirrups").onclick = () => this.onClick()
    document.getElementById("shear-y-breakout").onclick = () => this.onClick()

    this.configure()
  }
}

customElements.define('steel-dialog-component', SteelDialogComponent)














